function t(item) {
    var layer = item.layer;

    if (item.json["#document"]) {
        return item.json["#document"]
            .FeatureInfoResponse.FIELDS
            .map(f => f.$)
            .map(f => `${f.OBJECTID}: ${f.NAME} from ${layer.text}`)
            .join("");
    }

    if (item.json.features) {
        return item.json.features.map(f => JSON.stringify(f.properties)).join("\n");
    }

    console.warn("cannot render item");
    return "";

}

export = t; 